window.theme = window.theme || {};
theme.moneyFormat = theme.moneyFormat || "${{amount}}";

if (typeof Shopify === 'undefined') Shopify = {};
if (typeof Shopify.formatMoney === 'undefined') {
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    if (typeof format === 'undefined') {
      format = "${{amount}}";
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number) {
      var parts = number.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    value = formatWithDelimiters(cents / 100);
    return format.replace(placeholderRegex, value);
  };
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function removeHTML(str) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = str;
  return tmp.textContent || tmp.innerText || "";
}

// Updated slider function
function updateSlider(total_items, tiers) {
  if (!tiers || tiers.length === 0) return;
  
  const min = tiers[0].minItems;
  const max = tiers[tiers.length - 1].minItems;
  const pct = max > min
    ? Math.min(100, Math.round(((total_items - min) / (max - min)) * 100))
    : (total_items >= max ? 100 : 0);

  // Update fill
  const fillEl = document.querySelector('.slider-fill');
  if (fillEl) fillEl.style.width = pct + '%';

  // Update markers
  document.querySelectorAll('.slider-marker').forEach(marker => {
    const want = parseInt(marker.dataset.minItems, 10);
    marker.classList.toggle('active', total_items >= want);
  });
}

// Updated calculate_price function with enhanced slider integration
function calculate_price() {
  let total_items = 0;
  let total_price = 0;
  let original_total = 0;
  
  // Count total items
  $('.buy_item .item_qty').each(function(){
    total_items += parseInt($(this).text(), 10);
  });
  
  // Get discount from dynamic tiers
  const discount = window.getDiscountForQuantity(total_items);
  const nextTier = window.getNextTierInfo(total_items);
  
  // Calculate dynamic progress bar width for old progress bar (if exists)
  let filledWidth = '0%';
  if (window.bundleDiscountTiers && window.bundleDiscountTiers.length > 0) {
    const tiers = window.bundleDiscountTiers;
    const maxTier = tiers[tiers.length - 1];
    
    if (total_items >= maxTier.minItems) {
      filledWidth = '100%';
    } else if (total_items === 0) {
      filledWidth = '0%';
    } else {
      let progress = 0;
      const tierCount = tiers.length;
      
      for (let i = 0; i < tiers.length; i++) {
        if (total_items >= tiers[i].minItems) {
          progress = ((i + 1) / tierCount) * 100;
        } else {
          const prevMin = i > 0 ? tiers[i-1].minItems : 0;
          const currentMin = tiers[i].minItems;
          const tierProgress = (total_items - prevMin) / (currentMin - prevMin);
          progress = ((i + tierProgress) / tierCount) * 100;
          break;
        }
      }
      filledWidth = Math.min(progress, 100) + '%';
    }
  }
  
  // Update old progress bar (if exists)
  $('.buy_box .cust_progress_bar').toggleClass('show_success_msg', !nextTier);
  
  // Update NEW slider
  updateSlider(total_items, window.bundleDiscountTiers || []);
  
  // Update messages
  if (window.updateProgressMessage) {
    window.updateProgressMessage(total_items);
  }
  
  // Show/hide start message and button based on items
  if (total_items > 0) {
    $('.start_msg').hide();
    $('.btn_buy').show();
  } else {
    $('.start_msg').show();
    $('.btn_buy').hide();
  }
  
  // Calculate prices for each item
  $('.buy_item').each(function(){
    const $r = $(this).find('.r_price');
    const priceCents = parseInt($r.attr('data'), 10);
    
    if (discount > 0) {
      const discountedCents = Math.round(priceCents * (1 - discount/100));
      $r.text(Shopify.formatMoney(discountedCents, theme.moneyFormat));
      total_price += discountedCents;
    } else {
      $r.text(Shopify.formatMoney(priceCents, theme.moneyFormat));
      total_price += priceCents;
    }
    
    const $c = $(this).find('.c_price');
    if (!$c.hasClass('hide')) {
      original_total += parseInt($c.attr('data'), 10);
    } else {
      original_total += priceCents;
    }
  });
  
  // Update discount summary
  if (discount > 0) {
    $('.dis_price').text(Shopify.formatMoney(original_total - total_price, theme.moneyFormat));
    $('.dis_percnt').text(discount);
    $('.buy-text').removeClass('hidden');
  } else {
    $('.buy-text').addClass('hidden');
  }
  
  // Update total
  $('.total_price').text(Shopify.formatMoney(total_price, theme.moneyFormat));
}

function set_bundle() {
  if (getCookie('grmn_us_bundle') != '') {
    var bundle = {},
        $buy_html = $($('.buyitem_html').html()),
        buy_json,
        $product,
        price,
        c_price;

    bundle = decodeURI(getCookie('grmn_us_bundle'));
    bundle = JSON.parse(bundle);

    for (var bundle_id in bundle) {
      $buy_html = $buy_html.clone();
      $product = $('.product-card[data="' + bundle_id + '"]');
      buy_json = $product.find('.buy_json').html();
      buy_json = JSON.parse(buy_json);

      price = parseInt(buy_json.price);
      c_price = (buy_json.compare_price != '') ? parseInt(buy_json.compare_price) : 0;

      $buy_html.attr('handle', buy_json.handle);
      $buy_html.find('.item_name').text(buy_json.title);
      $buy_html.find('.item_qty').text(bundle[bundle_id]);
      $buy_html.find('.image_block img').attr('src', buy_json.image);

      if ($product.find('.skio-plan-picker .skio-group-input:checked[skio-one-time]').length) {
        $buy_html.find('.selling_plan_title').text('One-Time Purchase');
      } else {
        let frq_val = $product.find('.skio-plan-picker .skio-group-input:checked + label .skio-frequency').val();
        let frq_text = $product.find('.skio-plan-picker .skio-group-input:checked + label .skio-frequency option[value="' + frq_val + '"]').text();
        $buy_html.find('.selling_plan_title').text(frq_text);
      }

      $buy_html.attr('data', $product.find('input[name="id"]').val());
      $buy_html.find('.r_price').text(removeHTML(Shopify.formatMoney(price * parseInt(bundle[bundle_id]), theme.moneyFormat))).attr('data', price * parseInt(bundle[bundle_id]));

      if (c_price > price) {
        $buy_html.find('.r_price').addClass('sale-price');
        $buy_html.find('.c_price').text(removeHTML(Shopify.formatMoney(c_price * parseInt(bundle[bundle_id]), theme.moneyFormat))).attr('data', c_price * parseInt(bundle[bundle_id]));
      } else {
        $buy_html.find('.c_price').addClass('hide');
      }

      $product.find('.inputQty').val(bundle[bundle_id]);
      $('.added_products').append($buy_html);
    }

    if ($('.added_products').is(':empty')) {
      $('.buy_box').removeClass('active');
    } else {
      $('.buy_box').addClass('active');
    }

    calculate_price();
  }
}

function manage_cookie() {
  var varaints = {};
  $('.buy_item').each(function() {
    varaints[$(this).attr('data')] = $(this).find('.item_qty').text();
  });
  setCookie('grmn_us_bundle', encodeURI(JSON.stringify(varaints)), 365);
}

function remove_bundle() {
  // Since we're not using physical cart, just reset the UI
  $('.remove_bundle').removeClass('disabled');
  $('.btn_buy').find('.btn-text').text('Checkout');
  $('.btn_buy').removeClass('btn_buy_update');
}

function bundle_add(products_arr) {
  // Build Shopify cart permalink: /cart/VARIANT:QTY,VARIANT2:QTY2?checkout
  var cartItems = [];

  products_arr.forEach(function(product) {
    var sub_id = '';

    if ($('.product-card[data="' + product.id + '"] .skio-group-input[skio-one-time]:checked').length) {
      sub_id = null;
    } else {
      sub_id = parseInt($('.product-card[data="' + product.id + '"] .skio-group-container.skio-group-container--available .skio-group-input+label .skio-group-content select').val());
    }

    // Build cart item in format: VARIANT_ID:QUANTITY or VARIANT_ID:QUANTITY:SELLING_PLAN
    var cartItem = product.id + ':' + product.quantity;

    // Add selling plan if it's a subscription
    if (!isNaN(sub_id) && sub_id !== null) {
      cartItem += ':' + sub_id;
    }

    cartItems.push(cartItem);
  });

  // Build the cart permalink URL and redirect straight to checkout
  var checkoutUrl = '/cart/' + cartItems.join(',') + '?checkout';

  console.log('Redirecting to checkout with URL:', checkoutUrl);

  // Redirect to checkout
  window.location.href = checkoutUrl;
}

function manage_bundles(var_id, qty) {
  var $product = $('.bundles_collectiond .product-card[data="' + var_id + '"]'),
      buy_json,
      price,
      c_price,
      t_price,
      t_c_price,
      call_action = true;

  if (qty > 0) {
    $('.buy_item[data="' + var_id + '"] .item_qty').text(qty);

    if ($product.length) {
      buy_json = JSON.parse($product.find('.buy_json').html());
      price = parseInt(buy_json.price);
      c_price = (buy_json.compare_price != '') ? parseInt(buy_json.compare_price) : 0;
      t_price = price * parseInt(qty);

      $('.buy_item[data="' + var_id + '"] .r_price').text(removeHTML(Shopify.formatMoney(t_price, theme.moneyFormat))).attr('data', t_price);

      if (c_price > price) {
        t_c_price = c_price * parseInt(qty);
        $('.buy_item[data="' + var_id + '"] .c_price').text(removeHTML(Shopify.formatMoney(t_c_price, theme.moneyFormat))).attr('data', t_c_price);
      }
    }
  } else {
    $('.buy_item[data="' + var_id + '"]').remove();

    if ($('.added_products').is(':empty')) {
      setCookie('grmn_us_bundle', '', 0);
      $('.buy_box').removeClass('active');
      $('.buy_box .buy-text').addClass('hidden');
      $('.bundle_toggle').removeClass('active');
      $('.btn_buy').find('.btn-text').text('Checkout');
      $('.btn_buy').removeClass('btn_buy_update');
      call_action = false;
    }
  }

  $product.find('.inputQty').val(qty);

  if (call_action) {
    manage_cookie();
    calculate_price(); // This will now update the slider automatically
  }
}

function close_bundle_popup() {
  $('.bundle_popup').removeClass('active').delay(301).queue(function() {
    $(this).addClass('loading').dequeue();
  });
}

// Auto-close timer variable
let bundleAutoCloseTimer = null;
let wasAutoOpened = false; // Track if cart was auto-opened (vs manually opened)

// Function to auto-close bundle cart
function autoCloseBundleCart() {
  console.log('autoCloseBundleCart called');

  // If timer is already running, don't reset it (prevents stacking delays)
  if (bundleAutoCloseTimer) {
    console.log('Timer already running, ignoring new call');
    return;
  }

  // Set new timer to close after 3 seconds
  console.log('Setting new 3-second timer');
  bundleAutoCloseTimer = setTimeout(function() {
    console.log('Auto-closing cart after 3 seconds');
    $('.buy_box').removeClass('active open-box');
    $('.bundle_toggle').addClass('active');
    wasAutoOpened = false;
    bundleAutoCloseTimer = null; // Clear reference after execution
  }, 3000);
}

$(document).ready(function() {

  if ($('.template-page[data-suffix="build-your-bundles"]').length || $('.template-page[data-suffix="build-your-bundles-VIP"]').length) {
    set_bundle();
  }

  // Ensure toggle button is visible on page load
  if ($('.added_products').is(':empty')) {
    console.log('Cart is empty, showing toggle button');
    $('.bundle_toggle').addClass('active');
  } else {
    console.log('Cart has items:', $('.added_products').children().length);
  }
  console.log('Toggle button classes:', $('.bundle_toggle').attr('class'));
  console.log('Toggle button count:', $('.bundle_toggle').length);
  console.log('Buy box classes:', $('.buy_box').attr('class'));

  // Test if button is clickable
  if ($('.bundle_toggle').length > 0) {
    console.log('Toggle button found, checking if clickable...');
    console.log('Button CSS:', $('.bundle_toggle').css(['opacity', 'visibility', 'display', 'pointer-events', 'z-index']));
  }

  // Click outside to close bundle cart
  let clickOutsideEnabled = true;

  $(document).on('click', function(e) {
    if ($('.buy_box').hasClass('active') && clickOutsideEnabled) {
      console.log('Click detected, target:', e.target);
      // Check if click is outside buy_box, bundle_toggle, and bundle action buttons
      const clickedInside = $(e.target).closest('.buy_box').length > 0 ||
                           $(e.target).closest('.bundle_toggle').length > 0 ||
                           $(e.target).closest('.buy_action').length > 0 ||
                           $(e.target).hasClass('buy_action') ||
                           $(e.target).closest('.product-grid-addtocart').length > 0;

      console.log('Clicked inside cart/toggle?', clickedInside);

      if (!clickedInside) {
        console.log('Closing cart from outside click');
        $('.buy_box').removeClass('active open-box');
        $('.bundle_toggle').addClass('active');
        wasAutoOpened = false;
        // Clear auto-close timer since we're closing manually
        if (bundleAutoCloseTimer) {
          clearTimeout(bundleAutoCloseTimer);
          bundleAutoCloseTimer = null;
        }
      }
    }
  });

  // Pause auto-close timer when hovering over the cart (desktop) or touching it (mobile)
  $(document).on('mouseenter touchstart', '.buy_box', function() {
    if (bundleAutoCloseTimer) {
      clearTimeout(bundleAutoCloseTimer);
      bundleAutoCloseTimer = null;
    }
  });

  // Resume auto-close timer when leaving the cart (ONLY if it was auto-opened, not manually opened)
  $(document).on('mouseleave', '.buy_box', function() {
    if (wasAutoOpened && $('.buy_box').hasClass('active')) {
      console.log('Resuming auto-close timer after mouseleave');
      autoCloseBundleCart();
    }
  });

  // Initialize slider on page load
  const initialCount = $('.buy_item .item_qty').toArray()
    .reduce((s,el)=>s + (+$(el).text()||0), 0);
  
  if (initialCount > 0) {
    $('.start_msg').hide();
    $('.btn_buy').show();
  } else {
    $('.start_msg').show();
    $('.btn_buy').hide();
  }
  
  updateSlider(initialCount, window.bundleDiscountTiers || []);

  $('.qtybox .btnqty').on('click', function() {
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if ($(this).hasClass('qtyplus')) {
      qty++;
    } else {
      if (qty > 0) {
        qty--;
      }
    }
    qty = (isNaN(qty)) ? 0 : qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
  });

  $(document).on('click', '.close_buy', function(e) {
    e.preventDefault();
    $('.buy_box').removeClass('active');
    $('.bundle_toggle').addClass('active');
    wasAutoOpened = false;
    // Clear auto-close timer when manually closing cart
    if (bundleAutoCloseTimer) {
      clearTimeout(bundleAutoCloseTimer);
      bundleAutoCloseTimer = null;
    }
  });

  $(document).on('click', '.remove_btn', function() {
    var $buy_item = $(this).parents('.buy_item');
    var var_id = $buy_item.attr('data');

    $buy_item.remove();
    $('.product-card[data="' + var_id + '"]').find('.inputQty').val(0);

    if ($('.added_products').is(':empty')) {
      $('.buy_box').removeClass('active');
      if ($('.btn_buy').hasClass('btn_buy_update')) {
        remove_bundle();
      }
    }

    manage_cookie();
    calculate_price(); // This will update the slider
  });

  $(document).on('click', '.buy_action', function() {
    var $product = $(this).parents('.product-card');
    var $popup_qty;

    if ($(this).hasClass('popup_action')) {
      $product = $('.product-card[data="' + $(this).parents('.product_wrap').attr('data') + '"]');
      $popup_qty = $(this).parents('.product_wrap').find('.qty .inputQty');
      $product.find('.inputQty').val($popup_qty.val());
    }

    if (typeof $product == 'undefined') return;

    var $qty = $product.find('.inputQty');
    var buy_json = $product.find('.buy_json').html();
    var $buy_html = $($('.buyitem_html').html()),
        price,
        c_price,
        t_price,
        t_c_price;

    var var_id = $product.find('input[name="id"]').val();
    buy_json = JSON.parse(buy_json);

    if ($(this).hasClass('product-grid-addtocart')) {
      $qty.val(parseInt($qty.val()) + 1);

      if ($(this).hasClass('popup_action')) {
        $popup_qty.val(parseInt($popup_qty.val()) + 1);
        close_bundle_popup();
      }
    }

    price = parseInt(buy_json.price);
    c_price = (buy_json.compare_price != '') ? parseInt(buy_json.compare_price) : 0;

    if ($('.buy_item[data="' + var_id + '"]').length) {
      $('.buy_item[data="' + var_id + '"]').find('.item_qty').text($qty.val());
      t_price = price * parseInt($qty.val());

      $('.buy_item[data="' + var_id + '"] .r_price').text(removeHTML(Shopify.formatMoney(t_price, theme.moneyFormat))).attr('data', t_price);

      if (c_price > price) {
        t_c_price = c_price * parseInt($qty.val());
        $('.buy_item[data="' + var_id + '"] .c_price').text(removeHTML(Shopify.formatMoney(t_c_price, theme.moneyFormat))).attr('data', t_c_price);
      }
    } else {
      $buy_html.attr('handle', buy_json.handle);
      $buy_html.find('.item_name').text(buy_json.title);
      $buy_html.find('.item_qty').text($qty.val());
      $buy_html.find('.image_block img').attr('src', buy_json.image);

      if ($product.find('.skio-plan-picker .skio-group-input:checked[skio-one-time]').length) {
        $buy_html.find('.selling_plan_title').text('One-Time Purchase');
      } else {
        let frq_val = $product.find('.skio-plan-picker .skio-group-input:checked + label .skio-frequency').val();
        let frq_text = $product.find('.skio-plan-picker .skio-group-input:checked + label .skio-frequency option[value="' + frq_val + '"]').text();
        $buy_html.find('.selling_plan_title').text(frq_text);
      }

      $buy_html.attr('data', $product.find('input[name="id"]').val());
      $buy_html.find('.r_price').text(removeHTML(Shopify.formatMoney(price, theme.moneyFormat))).attr('data', price);

      if (c_price > price) {
        $buy_html.find('.r_price').addClass('sale-price');
        $buy_html.find('.c_price').text(removeHTML(Shopify.formatMoney(c_price, theme.moneyFormat))).attr('data', c_price);
      } else {
        $buy_html.find('.c_price').addClass('hide');
      }

      $('.added_products').append($buy_html);
    }

    if (!$product.find('.skio-group-input[skio-one-time]:checked').length) {
      var subscription_price = parseInt($product.find('.skio-group-container.skio-group-container--available .skio-group-input:checked+label .skio-price > span').attr('product_price')),
          _total_qty = parseInt($product.find('.qtybox .inputQty').val()),
          _total_price = subscription_price * _total_qty;

      if ($product.find('.subscription_picker .skio-plan-picker').length) {
        if ($('.buy_item[data="' + var_id + '"]').length) {
          $('.buy_item[data="' + var_id + '"] .r_price').text(removeHTML(Shopify.formatMoney(_total_price, theme.moneyFormat))).attr('data', _total_price);
        } else {
          $buy_html.find('.r_price').text(removeHTML(Shopify.formatMoney(_total_price, theme.moneyFormat))).attr('data', _total_price);
        }
      }
    }

    if (parseInt($qty.val()) == 0) {
      $('.buy_item[data="' + var_id + '"]').remove();
    }
    
    if ($('.added_products').is(':empty')) {
      $('.buy_box').removeClass('active open-box');
      $('.bundle_toggle').removeClass('active');
      wasAutoOpened = false;
    } else {
      // Temporarily disable click-outside when opening cart
      clickOutsideEnabled = false;

      $('.bundle_toggle').removeClass('active');
      $('.buy_box').addClass('active open-box');

      // Mark as auto-opened for hover behavior
      wasAutoOpened = true;

      // Re-enable click-outside after a short delay
      setTimeout(function() {
        clickOutsideEnabled = true;
        console.log('Click-outside re-enabled after add');
      }, 100);

      // Trigger auto-close timer when cart opens after adding item
      autoCloseBundleCart();
    }

    manage_cookie();
    calculate_price(); // This will update the slider
  });

  $(document).on('click', '.btn_buy', function() {
    if ($(this).hasClass('loading')) return;
    if (getCookie('grmn_us_bundle') == '') return;

    var products = JSON.parse(decodeURI(getCookie('grmn_us_bundle')));
    var products_arr = [];
    var counter = 0;

    $('.btn_buy').addClass('loading');

    // Build products array from current bundle
    for (var index in products) {
      products_arr[counter] = {};
      products_arr[counter]['id'] = index;
      products_arr[counter]['quantity'] = products[index];
      counter++;
    }

    // Go directly to checkout with line items (no cart interaction)
    bundle_add(products_arr);
  });

  $(document).on('click', '.remove_bundle', function() {
    if ($(this).is(':disabled')) return;

    remove_bundle();
    setCookie('grmn_us_bundle', '', 0);
    $('.buy_box').removeClass('active');
    $('.added_products').empty();
    $('.buy_box .buy-text').addClass('hidden');
    $('.bundles_collectiond .product-card .inputQty').val(0);
    $('.bundle_toggle').removeClass('active');
    $('.btn_buy').find('.btn-text').text('Checkout');
    $('.btn_buy').removeClass('btn_buy_update');

    // Update slider when bundle is removed
    calculate_price();
  });

  // Function to handle opening the cart from toggle button
  function openCartFromToggle() {
    console.log('Opening cart from toggle');

    // Temporarily disable click-outside
    clickOutsideEnabled = false;

    $('.bundle_toggle').removeClass('active');
    $('.buy_box').addClass('active open-box');  // ADD both classes, don't remove!
    console.log('Cart opened, classes:', $('.buy_box').attr('class'));

    // Mark as manually opened (no auto-close)
    wasAutoOpened = false;

    // Re-enable click-outside after a short delay
    setTimeout(function() {
      clickOutsideEnabled = true;
      console.log('Click-outside re-enabled');
    }, 100);

    // Clear auto-close timer when manually opening cart (no auto-close for manual open)
    if (bundleAutoCloseTimer) {
      clearTimeout(bundleAutoCloseTimer);
      bundleAutoCloseTimer = null;
    }
  }

  // Multiple selectors and event types to catch the button click
  $(document).on('click mousedown', '.bundle_toggle, .btn-bundle-toggle', function(e) {
    console.log('Bundle toggle ' + e.type + ' detected!', this);
    e.preventDefault();
    e.stopPropagation();

    if (e.type === 'click') {
      openCartFromToggle();
    }
  });

  // Also listen for clicks on child elements (spans inside the button)
  $(document).on('click', '.bundle_toggle *, .btn-bundle-toggle *', function(e) {
    console.log('Bundle toggle child clicked!', this);
    e.preventDefault();
    e.stopPropagation();
    openCartFromToggle();
  });

  $(document).on('click', '.edit_bundle', function(e) {
    e.preventDefault();

    if (location.pathname.indexOf('build-your-bundles') >= 0) {
      $('.widget-close').trigger('click');

      if ($('.added_products').is(':empty')) {
          $('.buy_box').removeClass('active');
      } else {
          $('.buy_box').addClass('active');
      }

      $('.bundle_toggle').removeClass('active');
    } else {
      location.href = '/pages/build-your-bundles';
    }
  });

  $(document).on('click', '.qty_cart [type="button"]', function() {
    var var_id = $(this).attr('data-id');
    var qty = $(this).parent('.qty_cart').find('.custom-qty').val();
    manage_bundles(var_id, qty); // This will update the slider
  });

  $(document).on('click', '.cart_bundle_action', function() {
    var var_id = $(this).attr('data-id');
    var qty = $(this).parents('.quantity_with_btn').find('.custom-qty').val();
    if ($(this).hasClass('jsItemRemove')) qty = 0;
    manage_bundles(var_id, qty); // This will update the slider
  });

  $(document).on('click', '.template-page[data-suffix="build-your-bundles"] .qty_selector .qty_change, .template-page[data-suffix="build-your-bundles-VIP"] .qty_selector .qty_change', function(e) {
    e.preventDefault();
    var product_id = $(this).parents('.added-product').attr('data');
    if ($(this).hasClass('qty_minus')) {
      $('.bundles_collectiond .collections_list .product-card[data="' + product_id + '"] .qtybox .btnqty.qtyminus').click();
    } else if ($(this).hasClass('qty_plus')) {
      $('.bundles_collectiond .collections_list .product-card[data="' + product_id + '"] .qtybox .btnqty.qtyplus').click();
    }
    // calculate_price will be called by the manage_bundles function triggered by the click above
  });

  $(document).on('click', '.js_single_variant_change', function() {
    var variantID = $(this).attr('variantID');
    $(this).parents('.product-card').find('.js_single_variant_change').removeClass('active');
    $(this).addClass('active');
    $(this).parents('.product-card').attr('data', variantID);
    $(this).parents('.product-card').find('input[name="id"]').attr({
      'value': variantID,
      'data-value': variantID
    });
  });

  $(document).on('change', '.skio-group-input', function() {
    var variant_id = $(this).parents('form').find('input[name="id"]').attr('data-value'),
        subscription_price = parseInt($(this).parents('form').find('.skio-group-container.skio-group-container--available .skio-group-input:checked+label .skio-price > span').attr('product_price')),
        regular_price = parseInt($(this).parents('form').find('.skio-group-container.skio-group-container--available .skio-group-input[skio-one-time]+label .skio-price > span').attr('regular_price')),
        _total_qty = parseInt($(this).parents('form').find('.qtybox .inputQty').val());

    if (this.hasAttribute('skio-one-time')) {
      var _total_price = regular_price * _total_qty;
      if ($('.added-product.buy_item[data="' + variant_id + '"]').length) {
        $('.added-product.buy_item[data="' + variant_id + '"] .r_price').text(removeHTML(Shopify.formatMoney(_total_price, theme.moneyFormat))).attr('data', _total_price);
      }
      $('.added-product.buy_item[data="' + variant_id + '"] .selling_plan_title').text('One-Time Purchase');
    } else {
      var _total_price = subscription_price * _total_qty;
      if ($('.added-product.buy_item[data="' + variant_id + '"]').length) {
        $('.added-product.buy_item[data="' + variant_id + '"] .r_price').text(removeHTML(Shopify.formatMoney(_total_price, theme.moneyFormat))).attr('data', _total_price);
      }
      let frq_val = $(this).parents('.skio-group-container').find('label .skio-frequency').val(),
          frq_text = $(this).parents('.skio-group-container').find('label .skio-frequency option[value="' + frq_val + '"]').text();
      $('.added-product.buy_item[data="' + variant_id + '"] .selling_plan_title').text(frq_text);
    }
    calculate_price(); // This will update the slider
  });

  $(document).on('change', '.subscription_picker .skio-plan-picker .skio-frequency', function() {
    var variant_id = $(this).parents('form').find('input[name="id"]').attr('data-value'),
        frq_val = $(this).val(),
        frq_text = $(this).find('option[value="' + frq_val + '"]').text();
    $('.added-product.buy_item[data="' + variant_id + '"] .selling_plan_title').text(frq_text);
  });

  $(document).on('click', '.js_subscription_atc', function() {
    var _this = $(this),
        pro_var_id = parseInt($(_this).parents('form').find('input[name="id"]').attr('data-value')),
        product_qty = parseInt($(_this).parents('form').find('input[name="quantity"]').val()),
        selling_plan_id = null;

    $(_this).addClass('loader_show');

    if (product_qty == 0) {
      product_qty = 1;
      $(_this).parents('form').find('input[name="quantity"]').val('1');
    }

    if (!$(_this).parents('form').find('.skio-group-input[skio-one-time]:checked').length) {
      selling_plan_id = parseInt($(_this).parents('form').find('.skio-group-container.skio-group-container--available .skio-group-content select').val());
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: pro_var_id,
        quantity: product_qty,
        selling_plan: selling_plan_id
      },
      success: function() {
        $(_this).removeClass('loader_show');
        window.location.href = '/cart';
      },
      error: function(error) {
        console.log(error.responseJSON.description);
        $(_this).removeClass('loader_show');
      }
    });
  });

  // Enhanced quantity selector handler - updates slider immediately
  $(document).on('click', '.qty_selector .qty_change', function (e) {
    e.preventDefault();
  
    const $qtyWrapper = $(this).closest('.qty_selector');
    const $qtyDisplay = $qtyWrapper.find('.item_qty');
    const varId = $(this).closest('.added-product').attr('data');
    let qty = parseInt($qtyDisplay.text());
  
    if ($(this).hasClass('qty_plus')) qty++;
    if ($(this).hasClass('qty_minus') && qty > 0) qty--;
  
    $qtyDisplay.text(qty);
    manage_bundles(varId, qty); // This will trigger calculate_price and update slider
  });
  
  // Proper close button behavior for cart box
  $(document).on('click', '.close_buy', function (e) {
    e.preventDefault();
    $('.buy_box').removeClass('active open-box');
    $('.bundle_toggle').addClass('active');
    wasAutoOpened = false;
    // Clear auto-close timer when manually closing cart
    if (bundleAutoCloseTimer) {
      clearTimeout(bundleAutoCloseTimer);
      bundleAutoCloseTimer = null;
    }
  });
});

// Initialize slider on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize slider with current bundle state
  const initial = Array.from(document.querySelectorAll('.buy_item .item_qty'))
                       .reduce((s,el) => s + (+el.textContent||0), 0);
  
  if (initial === 0) {
    $('.start_msg').show();
    $('.btn_buy').hide();
  } else {
    $('.start_msg').hide();
    $('.btn_buy').show();
  }
  
  updateSlider(initial, window.bundleDiscountTiers || []);
});